<template>
  <GenerateReport />
</template>

<script>
import GenerateReport from "@/components/ri3/ia/GenerateReport.vue"

export default {
  name: "IAReport",
  components: {
    GenerateReport
  },
  computed: {
    company() {
      return this.$store.state.app.company
    }
  },
  data() {
    return {
      members: []
    }
  }
}
</script>
